export enum ConnectType {
  INCALL = 'Incall',
  OUTCALL = 'Outcall',
  BOTH = 'Both',
}
